import { render } from "./App.vue?vue&type=template&id=b8c0be32"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b8c0be32&lang=scss"

import exportComponent from "/Users/david.haas/Documents/Projects/VSC/ommax-employer-branding-lp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__